import {
    chakra,
    Flex,
    Text
} from '@chakra-ui/react';

export const BadgeContainer = chakra(Flex, {
    label: 'ThreeEssentialsBadgeCustom_Container',
    baseStyle: {
        w: '548px',
        h: '150px',
        borderRadius: '20px',
        border: '1px solid',
        borderColor: 'secondary.500',
        padding: '20px',
        gap: '20px',
        backgroundColor: 'secondary.50',
        m: '12px',
        cursor: 'pointer',
        _hover: {
            transition: '0.2s ease',
            background: 'secondary.100'
        }
    }
});

export const IconContainer = chakra(Flex, {
    label: 'ThreeEssentialsBadgeCustom - IconContainer',
    baseStyle: {
        w: '60px',
        ['svg, svg path']: {
            fill: 'var(--3p-colors-secondary-400) !important',
            stroke: 'var(--3p-colors-secondary-400) !important'
        }
    }
});

export const Title = chakra(Text, {
    label: 'ThreeEssentialsBadgeCustom_Title',
    baseStyle: {
        fontSize: '22px',
        fontWeight: 500,
        color: 'neutral.900',
        lineHeight: '16.56px'
    }
});

export const Description = chakra(Text, {
    label: 'ThreeEssentialsBadgeCustom_Description',
    baseStyle: {
        fontSize: '16px',
        fontWeight: 400,
        color: 'neutral.700',
        lineHeight: '24px',
        m: '12px 0'
    }
});
